<div class="relative grid w-full items-center">
  <div
    class="ease-out-back relative grid size-full auto-cols-[100%] grid-flow-col justify-items-center transition-transform duration-1000"
    [style.transform]="'translateX(-' + index() * 100 + '%)'"
  >
    @for (matrix of matrices(); track $index) {
      <rid-word-matrix
        [matrix]="matrix"
        (selectionChanged)="selectionChanged.emit({ kind: $event.kind, index: [$index, $event.index[0], $event.index[1]] })"
      />
    }
  </div>

  <!-- arrows -->
  @if (index() > 0) {
    <rid-chevron
      class="absolute left-8 cursor-pointer"
      direction="LEFT"
      animate.enter="anim-pop-in"
      animate.leave="anim-pop-out"
      (click)="index.set(index() - 1)"
    />
  }
  @if (index() < matrices().length - 1) {
    <rid-chevron
      class="absolute right-8 cursor-pointer"
      direction="RIGHT"
      animate.enter="anim-pop-in"
      animate.leave="anim-pop-out"
      (click)="index.set(index() + 1)"
    />
  }
</div>
